import Vue from 'vue'
import Vuex from 'vuex'

import backup from './modules/backup'
import common from './modules/common'
import core from './modules/core'
import extensions from './modules/extensions'
import invoice from './modules/invoice'
import log from './modules/log'
import messages from './modules/messages'
import progress from './modules/progress'
import site from './modules/site'
import support from './modules/support'
import updates from './modules/updates'
import user from './modules/user'
import audit from './modules/audit'
import tag from './modules/tag'
import local from './modules/local'
import updatesite from './modules/updatesite'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const transformPlugin = store => {
  store.transformDataItem = (element) => {
    let transformed = {}

    transformed.id = element.id
    transformed.inProgress = element.process_state
    transformed.dirty = false
    transformed.details = false
    transformed.data = element

    return transformed
  }
}

const store = new Vuex.Store({
  modules: {
    backup,
    common,
    core,
    extensions,
    invoice,
    log,
    messages,
    progress,
    site,
    support,
    updates,
    user,
    audit,
    tag,
    local,
    updatesite
  },

  plugins: [transformPlugin],

  strict: debug,

  //
  // ███████╗████████╗ █████╗ ████████╗███████╗
  // ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
  // ███████╗   ██║   ███████║   ██║   █████╗
  // ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
  // ███████║   ██║   ██║  ██║   ██║   ███████╗
  // ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
  //
  state: {
    defaultLimit: 25,
    viewname: '',
    layout: '',
    tab: '',
    remainingfreedays: 0,
    menuCollapsed: true
  },

  //
  //  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
  // ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
  // ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
  // ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
  // ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
  //  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
  //
  getters: {

    layout (state) {
      return state.layout
    },

    tab (state) {
      return state.tab
    }

  },

  //
  // ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
  // ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
  // ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
  // ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
  // ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
  // ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
  //
  mutations: {

    setLayout (state, payload) {
      state.layout = payload
    },

    setTab (state, payload) {
      state.tab = payload
    },

    setViewname (state, payload) {
      state.viewname = payload
    },

    toggleMenu (state) {
      state.menuCollapsed = !state.menuCollapsed
    }
  }
})

// Subscribe to store updates
store.subscribe((mutation, state) => {
  const storeName = mutation.type.split('/')[0]
  const method = mutation.type.split('/')[1]

  if (storeName !== 'local') {
    return
  }

  if (method.indexOf('set') !== 0) {
    return
  }

  localStorage.setItem('backupMonkeyLocalState', JSON.stringify(state.local))
})
export default store
